import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as baseApi from '../../api/base-api';
import Image from '../../components/image/index'

import store from '../../../store';
import { propsRecievedOptions } from '../../actions/options-actions';

import './homePage.css';


class HomePage extends Component {
  constructor(props) {
    super()
    this.props = props
  }

  componentDidMount() {
    baseApi.getOptions()
  }

  componentWillReceiveProps(nextProps){
   store.dispatch(propsRecievedOptions(true));
  }

  render() {
    if (this.props.propsRecieved === true) {
       return (
          <Image imageData={this.props.imageData} className={"home"} />
        )
    } else {
      return(null)
    }
  } 
}

const mapStateToProps = (store) => {
  return {
    imageData: store.optionsState.optionsData.homepage_image,
    propsRecieved: store.optionsState.propsRecieved
  };
};

export default connect(mapStateToProps)(HomePage);


/** WEBPACK FOOTER **
 ** ./src/js/views/homePage/homePage.js
 **/